import { IconBase, IconComponent } from './BaseIcon';

export const ColorWheel: IconComponent = (props) => (
  <IconBase {...props}>
    <path
      fill="#662d91"
      d="M6.857 16a9.138 9.138 0 0 1 2.709-6.491L4.72 4.674A16 16 0 0 0 0 16v.354l6.857-.148V16Z"
    />
    <path
      fill="#ed1e79"
      d="M16 6.857V0A16 16 0 0 0 4.297 5.086l5.029 4.685A9.076 9.076 0 0 1 16 6.857Z"
    />
    <path
      fill="#8cc63f"
      d="M22.514 22.411a9.14 9.14 0 0 1-6.457 2.732V32a16.084 16.084 0 0 0 11.429-4.686Z"
    />
    <path
      fill="#0071bc"
      d="M16 25.143a9.144 9.144 0 0 1-6.446-2.663l-4.857 4.823A16.114 16.114 0 0 0 16.126 32h.754l-.331-6.857Z"
    />
    <path
      fill="#2e3192"
      d="M6.857 16H0a16.002 16.002 0 0 0 5.2 11.783l4.651-5.04A9.078 9.078 0 0 1 6.857 16Z"
    />
    <path
      fill="#fcee21"
      d="m32 15.714-6.857.172a.363.363 0 0 1 0 .114 9.046 9.046 0 0 1-3.029 6.777l4.709 5.12A16 16 0 0 0 32 16.114Z"
    />
    <path
      fill="#f7931e"
      d="m26.869 4.263-4.663 5.04A9.144 9.144 0 0 1 25.143 16H32a16 16 0 0 0-5.131-11.737Z"
    />
    <path
      fill="#c1272d"
      d="M16 6.857a9.143 9.143 0 0 1 6.469 2.686l4.857-4.846A16.002 16.002 0 0 0 16 0h-.686l.297 6.857Z"
    />
  </IconBase>
);
